import React, { useEffect, useState } from 'react';
import { CompositeView, GridView, SimpleView, useRouter } from '@digital/ui';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { EStatusOrdemCompra } from '@app/enums/EStatusOrdemCompra';
import { ETipoUsuario } from '@app/enums/ETipoUsuario';
import { hasPermission } from '@app/helpers/permissions';
import { OrdemCompraDadosGerais, getAbas, getDadosGerais } from '@app/api/sas/ordemCompra';
import AbaDadosGerais from './AbaDadosGerais';
import AbaFluxoProcesso from './AbaFluxoProcesso/indext';
import AbaHistoricoOrdemCompra from './AbaHistorico/AbaHistoricoOrdemCompra';
import AbaIntegracaoContrato from './AbaIntegracaoContrato';
import AbaRelHomologacao from './AbaRelatorioHomologacao';
import { ordemCompraIdState, reloadState, dadosGeraisState, fluxoProcessoState, statusCodigoState, demandaIdState, gestorOptionsState, gerenteAreaOptionsState, ordemCompraAbasState, reloadAbaStateState, reloadVendorListState, vendorListState, ordemCompraRodadaNegociacaoIdState, stepState, vendorListDocsState, modalAcoesIdState, reloadDadosGeraisState, desabilitarAcoesState } from './atoms';
import './custom.css';
import AbaSumario from './AbaSumario';
import AbaDocumentacao from './AbaDocumentacao';
import AbaAcoes from './AbaAcoesFornecedor';
import { usuarioLogadoState } from '@app/atoms';
import { getLoggedId } from '@app/helpers';
import AbaAditivos from './AbaAditivos';
import AbaChecklistReajuste from './AbaChecklistReajuste/AbaChecklistReajuste';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import AbaAcoesFornecedor from './AbaAcoesFornecedor';
import AbaAcoesGestor from './AbaAcoesGestor';


const OrdemCompra = () => {
  const { match } = useRouter();
  const [ordemCompraId, setOrdemCompraId] = useRecoilState(ordemCompraIdState);
  const [ordemCompraAbas, setOrdemCompraAbas] = useRecoilState(ordemCompraAbasState);
  const [dadosGerais, setDadosGerais] = useRecoilState(dadosGeraisState);
  const [fluxoProcessoId, setFluxoProcessoId] = useRecoilState(fluxoProcessoState);
  const [statusCodigo, setStatusCodigo] = useRecoilState(statusCodigoState);
  const [demandaId, setDemandaId] = useRecoilState(demandaIdState);
  const setDesabilitarAcoes = useSetRecoilState(desabilitarAcoesState);
  const reloadAbaState = useRecoilValue(reloadAbaStateState);
  const usuarioLogado = useRecoilValue(usuarioLogadoState);
  const modalAcoesId = useRecoilValue(modalAcoesIdState);
  const reloadDadosGerais = useRecoilValue(reloadDadosGeraisState);

  setOrdemCompraId(match.params.id);

  const [ehComprador, setEhComprador] = useState<boolean>(false);
  const [ehAditivo, setEhAditivo] = useState<boolean>(false);
  const [ehGestorTecnico, setEhGestorTecnico] = useState<boolean>(false);


  useEffect(() => {
    if (!ordemCompraId) return;
    getDadosGerais(ordemCompraId).then(data => {
        if (data) {
         if (data.reloadPage === true) {
            window.location.reload();
           return;
         }


          setDadosGerais(data);
          if (data.statusCodigo) {
            setStatusCodigo(data.statusCodigo);
            
            const desabilitarAcoes = [EStatusOrdemCompra.Cancelada, EStatusOrdemCompra.OnHoldAguardandoRequisitante].includes(data.statusCodigo);
            setDesabilitarAcoes(desabilitarAcoes);
          }
          if (data.fluxoProcessoId) setFluxoProcessoId(data.fluxoProcessoId);
          if (data.demandaId) setDemandaId(data.demandaId);
          if (data.compradorId) setEhComprador(data.compradorId == getLoggedId());
          if(data.tipo == ETipoDemanda.Aditivo || data.tipo == ETipoDemanda.AditivoFaturamentoDireto) setEhAditivo(true);
          if (data.gestorTecnicoId) setEhGestorTecnico(data.gestorTecnicoId == getLoggedId());
        }
      });
  }, [ordemCompraId, reloadDadosGerais]);

  useEffect(() => {
    if (!ordemCompraId) return;
    getAbas(ordemCompraId)
      .then(abas => {
        if (abas) {
          setOrdemCompraAbas(abas);
        }
      });
  }, [ordemCompraId, reloadAbaState]);


  return (
    <SimpleView>
      {ordemCompraAbas && ordemCompraId && usuarioLogado.id && dadosGerais && (
        <>
          {usuarioLogado.tipoUsuarioCodigo == ETipoUsuario.MRN ? (
            <CompositeView>

              {ordemCompraAbas.fluxoProcesso == true ? (
                <GridView icon='commons-document' title='Fluxo do Processo' id="fluxoProcesso" noform>
                  <AbaFluxoProcesso
                    statusCodigo={statusCodigo}
                    onStatusCodigo={setStatusCodigo}
                  />
                </GridView>
              ) : (() => { })}

              {ordemCompraAbas.dadosGerais == true ? (
                <GridView icon="commons-document" title="Dados Gerais" id="dadosGerais" noform>
                  <AbaDadosGerais />
                </GridView>
              ) : (() => { })}

              {ordemCompraAbas.integracaoContrato == true
                /*&& [
                  EStatusOrdemCompra.AguardandoAnaliseComercial,
                  EStatusOrdemCompra.AguardandoAprovacaoBoD,
                  EStatusOrdemCompra.AguardandoAprovacaoAssinatura,
                  EStatusOrdemCompra.Concluido,
                ].includes(statusCodigo)*/
                && hasPermission(["SAS_VISUALIZAR_INTEGRACAO_CONTRATO_TOTVS", "SAS_OC_ABA_INTEGRACAO_CONTRATO_TOTVS"]) || ehComprador ? (
                <GridView icon="commons-document" title={ehAditivo ? "Integração Aditivo" : "Integração Contrato"} id="integracaoContrato" noform>
                  <AbaIntegracaoContrato ehComprador={ehComprador} />
                </GridView>
              ) : (() => { })}

              {(
                ordemCompraAbas.integracaoContrato == true
                /*&& [
                  EStatusOrdemCompra.AguardandoAnaliseComercial,
                  EStatusOrdemCompra.AguardandoAprovacaoBoD,
                  EStatusOrdemCompra.AguardandoAprovacaoAssinatura,
                  EStatusOrdemCompra.Concluido,
                ].includes(statusCodigo)*/
                && hasPermission(["SAS_VISUALIZAR_INTEGRACAO_CONTRATO_TOTVS", "SAS_OC_ABA_INTEGRACAO_CONTRATO_TOTVS", "SAS_OC_ABA_ADITIVOS"]) || ehComprador
              )
                && (dadosGerais && (dadosGerais.tipo == ETipoDemanda.Aditivo || dadosGerais.tipo == ETipoDemanda.AditivoFaturamentoDireto)) ? (
                <GridView icon="business-accounting" title="ADITIVOS" id="aditivos" noform>
                  <AbaAditivos  ehComprador={ehComprador} />
                </GridView>
              ) : (() => { })}

              {ordemCompraAbas.relatorioHomologacao == true
                && (ehComprador || hasPermission(['SAS_RELATORIO_HOMOLOGACAO_ORDEM_DE_COMPRA', "SAS_OC_ABA_RELATORIO_HOMOLOGACAO"])) ? (
                <GridView icon="commons-document" title="RELATÓRIO DE HOMOLOGAÇÃO" id="relHomologacao" noform>
                  <AbaRelHomologacao ehComprador={ehComprador} />
                </GridView>
              ) : (
                () => { }
              )}

              {(ordemCompraAbas.checklistReajuste == true && (dadosGerais && dadosGerais.tipo == ETipoDemanda.Aditivo)) ? (
                <GridView icon='commons-document' title='Checklist Reajuste' id="checklistReajuste" noform>
                  <AbaChecklistReajuste ehComprador={ehComprador} />
                </GridView>
              ) : (
                () => { }
              )}

              {ordemCompraAbas.historico == true ? (
                <GridView icon="calendar-time_search" title="HISTÓRICO" id="historico" noform>
                  <AbaHistoricoOrdemCompra ordemCompraId={ordemCompraId} />
                </GridView>
              ) : (
                () => { }
              )}

              {ordemCompraAbas.sumarioOc == true ? (
                <GridView icon="business-accounting" title="SUMÁRIO - OC" id="sumario" noform>
                  <AbaSumario />
                </GridView>
              ) : (
                () => { }
              )}

              {ehGestorTecnico ? (
                <GridView icon="commons-document" title="Ações Gestor Técnico" id="AcoesGestor" noform>
                  <AbaAcoesGestor dadosGerais={dadosGerais} />
                </GridView>
              ) : (
                () => { }
              )}

            </CompositeView>
          ) : () => { }}

          {/* {usuarioLogado.tipoUsuarioCodigo == ETipoUsuario.FornecedorSas && hasPermission(["SAS_OC_FORNECEDOR_ABA_DOCUMENTACAO"]) ? ( */}
          {usuarioLogado.tipoUsuarioCodigo == ETipoUsuario.FornecedorSas ? (
            <CompositeView>
              <GridView icon="commons-document" title="Ações Fornecedor" id="AcoesFornecedor" noform>
                <AbaAcoesFornecedor dadosGerais={dadosGerais} />
              </GridView>
              <GridView icon="commons-document" title="Documentação" id="documentacao" noform>
                <AbaDocumentacao dadosGerais={dadosGerais} />
              </GridView>
            </CompositeView>
          ) : () => { }}
        </>
      )}
    </SimpleView>
  );
};

export default OrdemCompra;
